<template>
  <el-row class="cs-gradedCommission">
    <el-col :span="6">
      <el-input-number
        v-model="model.MinValue"
        :controls="false"
        placeholder="请输入价格"
      ></el-input-number>
    </el-col>
    <el-col class="cs-gradedCommission-linkMark" :span="2">-</el-col>
    <el-col :span="6">
      <el-input-number
        v-model="model.MaxValue"
        :controls="false"
        placeholder="请输入价格"
      ></el-input-number>
    </el-col>
    <el-col :span="1">&nbsp;</el-col>
    <el-col :span="6">
      <el-input
        v-model="model.CommissionPercentage"
        placeholder="请输入佣金"
        oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
        @blur="onCommissionPercentageChange"
        ><template slot="append">%</template></el-input
      >
    </el-col>
    <el-col :span="2">
      <el-button
        size="medium"
        type="text"
        icon="el-icon-delete"
        class="delete-button"
        @click="onDelete()"
        >删除</el-button
      >
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
.cs-gradedCommission {
  .el-input-number {
    width: auto;
  }
  .cs-gradedCommission-linkMark {
    text-align: center;
  }
  .delete-button {
    color: red;
  }
  /deep/ .el-input-group__append {
    padding: 0 5px;
  }
}
</style>

<script>
export default {
  props: {
    dataIn: {
      index: Number,
      model: {
        Id: Number,
        MinValue: Number,
        MaxValue: Number,
        CommissionPercentage: Number,
      },
    },
  },
  data() {
    return {
      model: {},
    };
  },
  components: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn) {
        this.model = this.dataIn.model;
      }
    },
    onCommissionPercentageChange(e) {
      this.model.CommissionPercentage = e.target.value;
    },
    onDelete() {
      this.$confirm("是否要删除该梯度佣金吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("delete", this.dataIn.index);
        })
        .catch(() => {});
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/gradedCommission.vue